import { useMutation } from '@tanstack/react-query';
import Link from 'next/link';
import { useState } from 'react';
import { SITEMAP } from '../../../config/sitemap';
import AuthPasswordReset from '../../../lib/api/portal-api-v2/auth/password-reset/start';
import { resetPasswordStart } from '../../../lib/api/portal-api/user/resetPasswordStart';
import ButtonWithIcon from '../../molecules/ButtonWithIcon';
import ProgressTracker from '../../molecules/ProgressTracker';
import ForgotPasswordStepOne from '../../organisms/ForgotPasswordStepOne';
import ForgotPasswordStepTwo from '../../organisms/ForgotPasswordStepTwo';
import {
  ForgotPasswordContainer,
  Body,
  TrackerWrapper,
  Inner,
} from './ForgotPassword.styled';

interface ForgotPasswordProps {
  initialStep?: number;
  initialEmail?: string;
}

const ForgotPasswordPage = (props: ForgotPasswordProps) => {
  const [state, setState] = useState({
    values: { email: '' },
    step: props.initialStep ?? 0,
    resendDisabled: false,
  });

  const mutation = useMutation({
    mutationFn: (input: { email: string }) =>
      AuthPasswordReset.APIRoute({ email: input.email }),
    onError: (error) => {
      let er = error as Error;

      return er;
    },
  });

  return (
    <ForgotPasswordContainer>
      <Inner>
        <Body>
          {state.step === 0 ? (
            <ForgotPasswordStepOne
              error={
                mutation.error && mutation.error instanceof Error
                  ? (mutation.error.cause as string)
                  : ''
              }
              onSubmit={async (values) => {
                const data = await mutation.mutateAsync(values);
                if (data === true) {
                  setState({
                    ...state,
                    step: 1,
                    values: {
                      email: values.email,
                    },
                  });
                }
              }}
            />
          ) : null}
          {state.step === 1 ? (
            <ForgotPasswordStepTwo
              email={state.values.email}
              onResendClick={async () => {
                const data = await mutation.mutateAsync(state.values);

                if (data === true) {
                  setState({
                    ...state,
                    resendDisabled: true,
                  });

                  setTimeout(() => {
                    setState((state) =>
                      state.resendDisabled
                        ? {
                            ...state,
                            resendDisabled: false,
                          }
                        : { ...state }
                    );
                  }, 15000);
                }
              }}
              resendDisabled={state.resendDisabled}
            />
          ) : null}
        </Body>
        <Link href={SITEMAP.LOGIN} passHref>
          <ButtonWithIcon size='lg' variant='subtle' iconName='leftArrow'>
            BACK TO LOG IN
          </ButtonWithIcon>
        </Link>
        <TrackerWrapper>
          <ProgressTracker activeStep={state.step} steps={3} />
        </TrackerWrapper>
      </Inner>
    </ForgotPasswordContainer>
  );
};

export default ForgotPasswordPage;
